<template>
  <div id="app">
    <!-- <router-view name="header"></router-view> -->
    <!-- <main> -->

   
    <fade-transition origin="center" mode="out-in" :duration="250">
      <router-view />
    </fade-transition>

    <!-- </main> -->
    <!-- <router-view name="footer"></router-view> -->
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition,
  },
  data: () => ({
    shown: false,
  }),

  

  methods: {
 
  }


};

</script>

<style scoped>
.demo_wrap {
  position: relative;
  background: #a49191;
  overflow: hidden;
  /* background-image: url("https://vivaticket.autsteeltech.com/wp-content/themes/boraticket/assets/img/xfooter-bg.webp.pagespeed.ic.bRCEzz3dJO.webp"); */
}
.demo_wrap {
  padding: 50px;
  position: relative;
  z-index: 2;
  color: azure;
}
/* You could use :after - it doesn't really matter */
.demo_wrap .ba {
  /* content: ' '; */
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
  opacity: 0.3;
  /* background-image: url("https://vivaticket.autsteeltech.com/wp-content/themes/boraticket/assets/img/xfooter-bg.webp.pagespeed.ic.bRCEzz3dJO.webp"); */

  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
}
</style>
